import React from "react"
import { Div, Text } from "atomize"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import { SUBSTITUTE_PAID_TO_COACH, SUBSTITUTE_PAID_TO_SCHOOL } from "../utils/billing.utils"

const OPTIONS = [
	{ value: SUBSTITUTE_PAID_TO_SCHOOL, text: "Il circolo" },
	{ value: SUBSTITUTE_PAID_TO_COACH, text: "Io, li do al circolo" },
]

// Chi nei corsi paga la volta paga il circolo: la domanda è solo chi ha
// preso i soldi. Due risposte che si vedono insieme, larghe quanto la riga
// dei metodi, perché è una scelta che sposta dei soldi e non un dettaglio:
// presi da te, a fine mese li trovi in "Da dare al circolo".
function PaidToChoice({ selected, onChange, accent }) {
	return (
		<Div m={{ b: "1rem" }}>
			<Text textSize="caption" textColor={theme.colors.text_light} m={{ b: "0.25rem" }}>
				Chi ha preso i soldi
			</Text>
			<Div d="flex" p="4px" rounded="20px" bg={theme.colors.surface} style={{ gap: "4px" }}>
				{OPTIONS.map(option => {
					const isSelected = option.value === selected

					return (
						<motion.div
							key={option.value}
							whileTap={{ scale: 0.97 }}
							style={{ flex: 1, minWidth: 0 }}>
							<Div
								h="2.75rem"
								d="flex"
								align="center"
								justify="center"
								p={{ x: "0.5rem" }}
								rounded="16px"
								cursor="pointer"
								transition
								bg={isSelected ? accent : "transparent"}
								role="radio"
								aria-checked={isSelected}
								onClick={() => !isSelected && onChange(option.value)}>
								<Text
									textSize="body"
									textWeight={isSelected ? "bold" : "normal"}
									textColor={isSelected ? theme.colors.white : theme.colors.gunmetal}
									style={{ whiteSpace: "nowrap" }}>
									{option.text}
								</Text>
							</Div>
						</motion.div>
					)
				})}
			</Div>
		</Div>
	)
}

export default PaidToChoice
